var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("HKLText", {
        attrs: { text: _vm.$t("settings.department.eCircularCategories.hint") },
      }),
      _vm._v(" "),
      _c(
        "Collapse",
        { attrs: { expand: true } },
        [
          _c("template", { slot: "title" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t(
                    "settings.department.eCircularCategories.tenantCategories"
                  )
                ) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "template",
            { slot: "content" },
            [
              _c(
                "HKLTable",
                _vm._b(
                  { staticClass: "categories-table" },
                  "HKLTable",
                  _vm.tenantCategoriesTableAttrs,
                  false
                )
              ),
              _vm._v(" "),
              _vm.isEditing
                ? _c("HKLButton", {
                    staticClass: "add-btn",
                    attrs: { action: "addPlus" },
                    on: {
                      click: function () {
                        return _vm.add("tenant")
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "Collapse",
        { attrs: { expand: true } },
        [
          _c("template", { slot: "title" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t(
                    "settings.department.eCircularCategories.vendorCategories"
                  )
                ) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "template",
            { slot: "content" },
            [
              _c(
                "HKLTable",
                _vm._b(
                  { ref: "form", staticClass: "categories-table" },
                  "HKLTable",
                  _vm.vendorCategoriesTableAttrs,
                  false
                )
              ),
              _vm._v(" "),
              _vm.isEditing
                ? _c("HKLButton", {
                    staticClass: "add-btn",
                    attrs: { action: "addPlus" },
                    on: {
                      click: function () {
                        return _vm.add("vendor")
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }